<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'ESR_are_you_sure.page_title'}}</h1>
     
     <div html='ESR_are_you_sure.expText'></div>
     
     <div class="btn-div">
          <div class="button-top">
                 <button [ngClass]="data.subject.language=='fr'?'btn-next2':'btn-next4'"   
                         title="{{'ESR_are_you_sure.backToBT_alt'|translate}}" (click)="onPreviousClick()" translate>
                         {{'ESR_are_you_sure.backToBT'}}
                 </button>
          </div>

          <div class="button-bottom">
                 <button [ngClass]="data.subject.language=='fr'?'btn-cancel2':'btn-cancel4'"
                         title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>
                       {{Button.Next}}
                 </button>
          </div>
     </div>

</div>
